var map = {
	"./1-consultor.png": "75cd",
	"./10-imperial-black-diamond.png": "6c4a",
	"./11-crown-black-diamond.png": "11ee",
	"./12-presidente.png": "c231",
	"./2-elite.png": "dd7b",
	"./3-sapphire.png": "9504",
	"./4-ruby.png": "c093",
	"./5-emerald.png": "c7a7",
	"./6-diamond.png": "59ab",
	"./7-blue-diamond.png": "7b21",
	"./8-red-diamond.png": "d611",
	"./9-black-diamond.png": "b44f",
	"./index.html": "2a19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";